import { styled, TextField } from "@mui/material";

export const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            // borderColor: '#999',
            border: "3px solid #999",
        },
    },
});

export const UpdatableField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            // borderColor: '#c2c2c2',
            border: "3px solid #c2c2c2",
        },
    },
});